import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../utils/Functions';


const FauxWindow = ({ width, height, trimWidth, isOverlap, overlapTrimColor, glassTexture, doorColor }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])


    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth * 1.5, height / 2 - trimWidth * 1.5);
        hole.lineTo(width / 2 - trimWidth * 1.5, height / 2 - trimWidth * 1.5);
        hole.lineTo(width / 2 - trimWidth * 1.5, -height / 2 + trimWidth * 1.5);
        hole.lineTo(-width / 2 + trimWidth * 1.5, -height / 2 + trimWidth * 1.5);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const windowInsideModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth * 1.5, height / 2 - trimWidth * 1.5);
        model.lineTo(width / 2 - trimWidth * 1.5, height / 2 - trimWidth * 1.5);
        model.lineTo(width / 2 - trimWidth * 1.5, -height / 2 + trimWidth * 1.5);
        model.lineTo(-width / 2 + trimWidth * 1.5, -height / 2 + trimWidth * 1.5);
        model.closePath();

        return model;
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        let model = [];

        const railThickness = trimWidth / 5 * 4
        const railWidth = width - trimWidth * 2;
        const railHeight = height - trimWidth * 2;

        const horizontalLeftModel = new THREE.Shape();
        horizontalLeftModel.moveTo(-railWidth / 2, -railHeight / 2 - railThickness);
        horizontalLeftModel.lineTo(-railWidth / 2, -railHeight / 2 + railThickness * 2.5);
        horizontalLeftModel.lineTo(railWidth / 2, railHeight / 2 + railThickness);
        horizontalLeftModel.lineTo(railWidth / 2, railHeight / 2 - railThickness * 2.5);
        horizontalLeftModel.closePath();

        const horizontalRightModel = new THREE.Shape();
        horizontalRightModel.moveTo(-railWidth / 2, railHeight / 2 + railThickness);
        horizontalRightModel.lineTo(-railWidth / 2, railHeight / 2 - railThickness * 2.5);
        horizontalRightModel.lineTo(railWidth / 2, -railHeight / 2 - railThickness);
        horizontalRightModel.lineTo(railWidth / 2, -railHeight / 2 + railThickness * 2.5);
        horizontalRightModel.closePath();

        model.push(horizontalLeftModel);
        model.push(horizontalRightModel);

        return model;
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.35)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            {/* <mesh name='door-inside' position={[0, 0, 0.075]}>
                <extrudeGeometry args={[windowInsideModel, extrudeSettings(0.15)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} />
            </mesh> */}
            <mesh name='rail' position={[0, 0, 0.03]}>
                <extrudeGeometry args={[railModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial  color={trimColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
        </>
    )
}

export default FauxWindow